import $ from "jquery";
import Plyr from 'plyr';
import styles from 'plyr/dist/plyr.css';

$('.common-video-plyr').each(function(){
  var $element = $(this);
  
  // Extract the YouTube video ID from the data attribute (if needed)
  var videoId = $element.data('video-id'); // Assumes a data-video-id attribute for video ID

  // Update the iframe src to include YouTube parameters
  var iframe = $element.find('iframe');
  if (iframe.length) {
    var src = iframe.attr('src');
    src += (src.indexOf('?') === -1 ? '?' : '&') + 'rel=0&controls=0&disablekb=1&modestbranding=1&iv_load_policy=3&showinfo=0&fs=0&cc_load_policy=0&disable_polymer=true';
    iframe.attr('src', src);
  }

  const player = new Plyr($element[0], {
    controls: ['play-large', 'play', 'progress', 'mute', 'volume'],
    autoplay: true,
    muted: true,
    youtube: {
      noCookie: true, // Use the YouTube no cookie URL
      rel: 0, // Disable related videos
      showinfo: 0, // Hide video title
      iv_load_policy: 3, // Hide annotations
      controls: 0 // Hide YouTube controls
    }
  });
});